import { PictureAsPdfSharp } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useCreateOrderFullPdf } from 'modules/orders/hooks'
import { ActionsItemProps } from './actions'

export const OrderFullPdf = ({ order, disabled }: ActionsItemProps) => {
  const { mutate, isLoading } = useCreateOrderFullPdf()

  const handleClick = () => {
    mutate({ orderId: order.orderId })
  }

  return (
    <MenuItem
      disabled={isLoading || disabled}
      onClick={handleClick}
      disableRipple
    >
      <PictureAsPdfSharp />
      Gerar PDF Completo
    </MenuItem>
  )
}
